/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

// Inicia o timer quando o elemento existir
  function initCartTimer() {
    var timeEl = document.querySelector('.cart-timer__time');
    if (!timeEl || timeEl.dataset.timerInitialized === 'true') {
      return;
    }

    // marcar como iniciado para não criar vários timers
    timeEl.dataset.timerInitialized = 'true';

    // tempo de reserva em minutos
    var startMinutes = 10; // <-- muda aqui se quiseres outro valor
    var totalSeconds = startMinutes * 60;
    var timerInterval = null;

    function updateTimer() {
      var minutes = Math.floor(totalSeconds / 60);
      var seconds = totalSeconds % 60;

      var mm = minutes < 10 ? '0' + minutes : String(minutes);
      var ss = seconds < 10 ? '0' + seconds : String(seconds);

      timeEl.textContent = mm + ':' + ss;

      if (totalSeconds <= 0) {
        clearInterval(timerInterval);
        // opcional: mensagem quando acaba
        // timeEl.closest('.cart-timer').textContent = 'Čas rezervacije je potekel.';
        return;
      }

      totalSeconds--;
    }

    updateTimer();
    timerInterval = setInterval(updateTimer, 1000);
  }

  document.addEventListener('DOMContentLoaded', function () {
    // tenta iniciar logo
    initCartTimer();

    // se o conteúdo do carrinho for carregado depois, vamos verificando
    setInterval(initCartTimer, 500);
  });

  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
